/*
 * SYB import-charges notice for Rebuy Smart Cart (SO-13278).
 * Loaded ONLY for non-US shoppers (Liquid gate in layout/theme.liquid).
 * The notice HTML and all its logic come from snippets/syb-import-notice.liquid,
 * fetched via the Section Rendering API; this file only places it in the cart.
 */
(function () {
  var SECTION = 'syb-import-notice';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var html = null;
  var timer = null;

  function load() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        var section = (json && json[SECTION]) || '';
        html = section.indexOf('data-syb-import-notice') !== -1 ? section : '';
      })
      .catch(function () {});
  }

  function place() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || html === null) return;
    var slot = cart.querySelector('[data-syb-import-notice-slot]');
    if (!html) {
      if (slot) slot.remove();
      return;
    }
    // The subtotal's wrapper is a flex row; insert above that row, in the
    // flex-column footer, so the notice spans the full width.
    var subtotal = cart.querySelector('.rebuy-cart__flyout-subtotal');
    var row = subtotal && subtotal.parentNode;
    if (!row || !row.parentNode) return;
    if (!slot) {
      slot = document.createElement('div');
      slot.setAttribute('data-syb-import-notice-slot', '');
      row.parentNode.insertBefore(slot, row);
    }
    if (slot._sybHtml !== html) {
      slot.innerHTML = html;
      slot._sybHtml = html;
    }
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      load().then(place);
    }, 150);
  }

  var observed = false;
  function observe() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart || observed) return;
    observed = true;
    // Smart Cart re-renders can drop the slot; put it back.
    new MutationObserver(function () {
      if (html && !cart.querySelector('[data-syb-import-notice-slot]')) place();
    }).observe(cart, { childList: true, subtree: true });
  }

  document.addEventListener('rebuy:cart.change', refresh);
  document.addEventListener('rebuy:smartcart.ready', function () {
    observe();
    refresh();
  });
  document.addEventListener('rebuy:smartcart.show', function () {
    observe();
    if (html === null) refresh();
    else place();
  });
  // Smart Cart may have initialized before this deferred script ran.
  if (document.getElementById('rebuy-cart')) {
    observe();
    refresh();
  }
})();
